var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "nav-bar" }, [
      _c(
        "a",
        {
          staticClass: "nav-bar-close-button",
          on: { click: _vm.onCloseClicked }
        },
        [_c("span", { staticClass: "b-sprite-quiz-v3-x-black-large" })]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "tangrams-container" }, [
      _c("canvas", { ref: "canvas", staticClass: "tangrams" })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }